import React from 'react';
import { Globe } from 'lucide-react';
import { platforms } from './constants';
import { InfoTooltip } from './InfoTooltip';
import type { ConnectedAccount } from './types';

interface PlatformSelectorProps {
  selectedPlatform: string;
  selectedAccount: string | null;
  connectedAccounts: ConnectedAccount[];
  onPlatformSelect: (platform: string) => void;
  onAccountSelect: (accountId: string) => void;
}

export const PlatformSelector: React.FC<PlatformSelectorProps> = ({
  selectedPlatform,
  selectedAccount,
  connectedAccounts,
  onPlatformSelect,
  onAccountSelect,
}) => {
  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
        Platform & Account
        <InfoTooltip
          text="Select which social media platform to post to and choose your connected account. You can only select one platform per task."
          position="bottom"
        />
      </label>
      <div className="space-y-4">
        <div className="flex flex-wrap gap-2">
          {platforms.map((platform) => {
            const Icon = platform.icon;
            return (
              <button
                key={platform.id}
                onClick={() => onPlatformSelect(platform.id)}
                className={`
                  flex items-center gap-2 px-4 py-2 rounded-lg flex-1 justify-center sm:flex-none
                  ${selectedPlatform === platform.id ? 'bg-blue-600 text-white' : 'bg-gray-100'}
                `}
              >
                <Icon className="w-5 h-5" />
                <span>{platform.name}</span>
              </button>
            );
          })}
        </div>

        {connectedAccounts.length > 0 && (
          <div className="grid grid-cols-1 gap-2">
            {connectedAccounts.map((account) => {
              const platform = platforms.find(p => p.id === account.platform);
              const Icon = platform?.icon || Globe;
              return (
                <button
                  key={account.id}
                  onClick={() => onAccountSelect(account.id)}
                  className={`
                    flex items-center gap-2 p-3 rounded-lg border text-left
                    ${selectedAccount === account.id ? 'border-blue-500 bg-blue-50' : 'border-gray-200'}
                  `}
                >
                  <Icon className="w-5 h-5 flex-shrink-0" />
                  <span className="truncate">{account.name}</span>
                </button>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};